import React, { useState } from 'react'
import ReactModal from 'react-modal'
import { toast } from 'react-toastify';
import './modals.scss'

ReactModal.setAppElement("#root")

export default function DeleteDetailImageConfirmationModal(props) {
    return (
        <ReactModal
            isOpen={props.isOpen}
            onRequestClose={() => props.handleModalClose()}
            style={{
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                width: '50%',
                height: '200px'
            }}

        >
            <div id="deleteImage">
                <h2>Are you sure?</h2>
                <div id="modalButtons">
                    <div id="cancelButton" onClick={props.handleModalClose}>Cancel</div>
                    <div id="updateButton" onClick={() => { props.deleteImage(props.index) }}>Delete</div>
                </div>
            </div>
        </ReactModal>
    )
}
